module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/429.2bc549cd.png";